import React from 'react';
import { TextInput, NumberInput, LongTextInput, DatePicker, DropdownSelector } from 'hyperdb-utils';
import CustomersSelector from '../../common/CustomersSelector';
import OriginSelector from '../../common/OriginSelector';
import moment from 'moment';
import api from 'api';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeCustomer = this.handleChangeCustomer.bind(this);
    this.handleCustomerCreated = this.handleCustomerCreated.bind(this);
  }
  componentDidMount() {
    this.fetchProperties();
  }
  render() {
    const {arrival_date, departure_date} = this.props.objectData;
    const properties = this.props.api.getState('property').properties;
    const arrivalMaxDate = departure_date ?
      moment(departure_date).subtract(1, 'day')
      : undefined;
    const departureMinDate = arrival_date ?
      moment(arrival_date).add(1, 'day')
      : undefined;
    const openFrom = arrival_date && arrivalMaxDate ? (arrival_date < arrivalMaxDate ? arrival_date : arrivalMaxDate) : arrivalMaxDate || arrival_date;
    const openTo = departure_date && departureMinDate ? (departure_date > departureMinDate ? departure_date : departureMinDate) : departureMinDate || departure_date;
    const propertyId = this.props.objectData.property ? this.props.objectData.property.value[1] : '';
    const customerId = this.props.objectData.customer ? this.props.objectData.customer.value[1] : '';
    return (
      <div>
        <fieldset>
          <DatePicker
            label="Date *"
            name="creation_date"
            value={ this.props.objectData.creation_date }
            onChange={ this.handleChange.bind(this, 'creation_date') }
          />
          <OriginSelector
            required={ true }
            value={ this.props.objectData.origin }
            onChange={ this.handleChange.bind(this, 'origin') }
          />
          <DropdownSelector
            label="Property *"
            name="property"
            value={ propertyId }
            options={ propertiesOptions(properties) }
            onChange={ this.handleChangeRelation.bind(this, 'property') }
          />
          <CustomersSelector
            required={ true }
            customerId={ customerId }
            onChange={ this.handleChangeCustomer }
            onCustomerCreated={ this.handleCustomerCreated }
          />
        </fieldset>
        <fieldset>
          <DatePicker
            label="Arrival *"
            name="arrival_date"
            value={ this.props.objectData.arrival_date }
            maxValue={ arrivalMaxDate }
            openToDate={ openFrom }
            onChange={ this.handleChangeDate.bind(this, 'arrival_date') }
          />
          <DatePicker
            label="Departure *"
            name="departure_date"
            value={ this.props.objectData.departure_date }
            minValue={ departureMinDate }
            openToDate={ openTo }
            onChange={ this.handleChangeDate.bind(this, 'departure_date') }
          />
        </fieldset>
        <fieldset>
          <NumberInput
            label="Adults"
            name="nb_adults"
            value={ this.props.objectData.nb_adults }
            onChange={ this.handleChange.bind(this, 'nb_adults') }
          />
          <NumberInput
            label="Young adults"
            name="nb_young_adults"
            value={ this.props.objectData.nb_young_adults }
            onChange={ this.handleChange.bind(this, 'nb_young_adults') }
          />
          <NumberInput
            label="Children"
            name="nb_children"
            value={ this.props.objectData.nb_children }
            onChange={ this.handleChange.bind(this, 'nb_children') }
          />
          <NumberInput
            label="Young children"
            name="nb_young_children"
            value={ this.props.objectData.nb_young_children }
            onChange={ this.handleChange.bind(this, 'nb_young_children') }
          />
          <NumberInput
            label="Babies"
            name="nb_babies"
            value={ this.props.objectData.nb_babies }
            onChange={ this.handleChange.bind(this, 'nb_babies') }
          />
        </fieldset>
        <fieldset>
          <LongTextInput
            label="Message"
            name="message"
            value={ this.props.objectData.message }
            onChange={ this.handleChange.bind(this, 'message') }
          />
          <LongTextInput
            label="Remarks"
            name="remarks"
            value={ this.props.objectData.remarks }
            onChange={ this.handleChange.bind(this, 'remarks') }
          />
        </fieldset>
      </div>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.inquiry.updateEditedObject({ attributeName, value });
  }
  handleChangeDate(attributeName, field) {
    const { name, value } = field;
    const date = value ? moment(value).format('YYYY-MM-DD') : null;
    this.handleChange(attributeName, { value: date });
  }
  handleChangeRelation(attributeName, field) {
    const { name, value } = field;
    let collectionName;
    if (attributeName === 'property') collectionName = 'properties';
    if (attributeName === 'customer') collectionName = 'customers';
    const reference = { ...this.props.objectData[attributeName], value: [collectionName, value] };
    this.props.api.inquiry.updateEditedObject({ attributeName, value: reference });
  }
  handleChangeCustomer(customerId) {
    this.handleChangeRelation('customer', { value: customerId });
  }
  handleCustomerCreated(customer) {
    this.handleChangeRelation('customer', { value: customer.id });
  }

  fetchProperties() {
    this.props.api.property.getObjects({
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  fetchCustomers() {
    this.props.api.customer.getObjects({
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
}

function propertiesOptions(properties) {
  if (!properties) return [];
  return properties.map(property => {
    return { name: property.name, value: property.id };
  });
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};

export default api.connect(Form, 'inquiry');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/components/Form.jsx